import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { route } from '@helpers'
import React from 'react'

export default function Owner({ club }: Props) {
    return (
        <Grid columns="3">
            <Grid gap="15px">
                <Grid gap="10px">
                    <h1 className="h3">You're the head of the group</h1>
                    <p>The invitation link for {club.name} is working. You can send it to invite new people.</p>
                </Grid>
                <Flex><Button width="auto" to={route("club:customer")}>Visit group</Button></Flex>
            </Grid>
        </Grid>
    )
}

interface Props {
    club: Resources.ClubPartial
}